/**
 * @fileoverview GET handler for the "/apps/:app_id/fsa_credential" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAppIdFirebaseCredential } from "./constants";
import type { AppsAppIdGetFirebaseCredentialInfoResult } from "./types";

export const getAppsAppIdFirebaseCredential = reactQueryFetcherAdapter(
  appsAppIdFirebaseCredential,
  (signal: AbortSignal, appId: string): Promise<AppsAppIdGetFirebaseCredentialInfoResult> => {
    return fetch(`/apps/${appId}/fsa_credential`, "GET", {}, { signal }, { propagateFetchRequestError: false });
  }
);
